module.exports = __webpack_public_path__ + "img/view_stream.2b7b5306.svg";